import {
  CONTRACT_SIDE_MENU,
  TOGGLE_SIDE_MENU,
  GeneralState,
  GeneralActionTypes,
  SET_COMPANIES,
  SELECT_COMPANY
} from 'types/store';

const initialState: GeneralState = {
  mobileSideMenuOpen: false,
  companies: [],
  selectedCompanyId: '',
  selectedCompanyLegalName: ''
};

const general = (state: GeneralState = initialState, action: GeneralActionTypes) => {
  switch (action.type) {
    case CONTRACT_SIDE_MENU:
      return {
        ...state,
        mobileSideMenuOpen: false
      };
    case TOGGLE_SIDE_MENU:
      return {
        ...state,
        mobileSideMenuOpen: !state.mobileSideMenuOpen
      };
    case SET_COMPANIES:
      return {
        ...state,
        companies: action.companies,
        selectedCompanyId: action.companies.length ? action.companies[0].id : '',
        selectedCompanyLegalName: action.companies.length ? action.companies[0].legal_name : ''
      };
    case SELECT_COMPANY: {
      const selected = state.companies?.find(c => c.id === action.selectedCompanyId);
      return {
        ...state,
        selectedCompanyId: action.selectedCompanyId,
        selectedCompanyLegalName: selected ? selected.legal_name : state.selectedCompanyLegalName
      };
    }
    default:
      return state;
  }
};

export default general;
